export const MET_COMPANY_ORDER_COMMISSION_REQUEST = "MET_COMPANY_ORDER_COMMISSION_REQUEST";
export const MET_COMPANY_ORDER_COMMISSION_SUCCESS = "MET_COMPANY_ORDER_COMMISSION_SUCCESS";
export const MET_COMPANY_ORDER_COMMISSION_FAILED = "MET_COMPANY_ORDER_COMMISSION_FAILED";